import React, { Fragment, useEffect, useState } from 'react'
import Tour from 'components/molecules/tour'
import TourAlert from 'components/molecules/tourAlert'
import { computeTourState, tourAlertViewed } from './helpers'
import type { TourStep } from 'types'
import useFeatureTourSettings from 'hooks/featureTours/useFeatureTourSettings'

type Props = {
  feature: string;
  steps: TourStep[];
  message?: string;
  showTourAlert?: boolean;
};

const TourTemplate = (props: Props) => {
  const { feature = '', steps, message, showTourAlert } = props
  const { featureTourSettings: featureTours, updateFeatureTourSettings: updateFeatureTour } =
    useFeatureTourSettings(feature)
  const [run, setRun] = useState(false)

  const featureTour = featureTours[feature]

  const shouldRun = !showTourAlert || tourAlertViewed({ featureTour })

  useEffect(() => {
// @ts-expect-error - TS2345 - Argument of type 'boolean | undefined' is not assignable to parameter of type 'SetStateAction<boolean>'.
    setRun(shouldRun)
  }, [shouldRun])

// @ts-expect-error - TS2345 - Argument of type '{ feature: string; featureTour: any; steps: TourStep[]; run: boolean | undefined; }' is not assignable to parameter of type '{ featureTour: any; steps: TourStep[]; run: boolean | null | undefined; }'.
  const { stepsArr, phase, unviewedReturning } = computeTourState({ feature, featureTour, steps, run: shouldRun })

  if (!featureTours) return null
  if (Object.keys(featureTours).length === 0) return null

  const handleStart = () => setRun(true)

  return (
    <Fragment>
      {
        showTourAlert && !run &&
        <TourAlert
          feature={feature}
          featureTours={featureTours}
          message={message}
          onStart={handleStart}
          updateFeatureTour={updateFeatureTour}
          steps={stepsArr}
        />
      }
      <Tour
        feature={feature}
        featureTours={featureTours}
        run={run}
        steps={stepsArr}
        updateFeatureTour={updateFeatureTour}
        phase={phase}
        unviewedReturning={unviewedReturning}
      />
    </Fragment>
  )
}

export default TourTemplate
